import { defineComponent as _defineComponent } from 'vue'
import { ref,computed, watch, nextTick } from 'vue'  
  import store from '@/store'   
  import { AloDbFleet } from '@/models/alodb/AloDbFleet'
  import deepEqual from 'deep-equal' 

 
export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDetailSmartControl',
  props: {
    fleet: null,
    isleft: { type: Boolean },
    uiid: null,
    isVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
   fleet:AloDbFleet, 
   isleft:boolean,
   uiid:string, 
   isVisible:boolean
 };

 
  

 
 const modified = computed(() => store.myGetters.modifiedAdmAdminFleet as AloDbFleet)
 const original = computed(() => store.myGetters.originalAdmAdminFleet as AloDbFleet)    

 const btnActif = computed(() => !deepEqual(original.value, modified.value) /*&& !editCoverageState.value!.saving*/)
  

 async function saveConfig() {     
    await store.myActions.ADMINFLEET_SAVE_REQUEST()    
  }



return { __sfc: true,props, modified, original, btnActif, saveConfig, store }
}

})